export const ENV_NAME = {
  prod: "PROD",
  test: "TEST",
  dev: "DEV",
};
